import { useEffect } from 'react';

/**
 * O reflexo que segue o ponteiro, para TODA superfície de vidro da aplicação.
 *
 * O gradiente já está declarado no tema (`MuiCard` → `&::after`); o que falta é
 * alguém dizer onde o ponteiro está. Este componente instala UM ouvinte no
 * documento e escreve duas variáveis CSS no cartão sob o cursor.
 *
 * POR QUE DELEGADO, E NÃO UM `onMouseMove` POR CARTÃO. Uma tela do Painel tem
 * sete cartões; a de Resultado, quatro mais dois gráficos. Um manipulador de
 * React por cartão significa um `setState` por pixel de movimento — o caminho
 * mais rápido para transformar um efeito de acabamento em travamento. Aqui não
 * há re-render nenhum: a escrita é direta no `style` do elemento, agendada num
 * `requestAnimationFrame`, no máximo uma por quadro.
 *
 * Respeita `prefers-reduced-motion` e ponteiro grosso: no celular o gradiente
 * ficaria congelado no último ponto tocado, o que parece defeito, e o próprio
 * tema já o esconde em `pointer: coarse`.
 */
const ReflexoDeVidro = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const semPonteiroFino = window.matchMedia('(pointer: coarse)').matches;
    const menosMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (semPonteiroFino || menosMovimento) return undefined;

    let quadro = null;
    let pendente = null;

    const pintar = () => {
      quadro = null;
      if (!pendente) return;
      const { alvo, x, y } = pendente;
      pendente = null;
      alvo.style.setProperty('--px', `${x}px`);
      alvo.style.setProperty('--py', `${y}px`);
    };

    const aoMover = (evento) => {
      const alvo = evento.target instanceof Element ? evento.target.closest('.MuiCard-root') : null;
      if (!alvo) return;
      const caixa = alvo.getBoundingClientRect();
      pendente = { alvo, x: evento.clientX - caixa.left, y: evento.clientY - caixa.top };
      if (quadro === null) quadro = window.requestAnimationFrame(pintar);
    };

    document.addEventListener('mousemove', aoMover, { passive: true });
    return () => {
      document.removeEventListener('mousemove', aoMover);
      if (quadro !== null) window.cancelAnimationFrame(quadro);
    };
  }, []);

  return null;
};

export default ReflexoDeVidro;
